import { Mountain, Waves, ShieldCheck, Sun, Wrench, BatteryCharging } from "lucide-react";

const FEATURES = [
  {
    icon: Mountain,
    title: "Genuine 4-wheel drive",
    body: "Four independent 750 W hub motors and patented all-round independent suspension. Climb 35° gradients and handle 25° side tilt without losing your line.",
    span: "md:col-span-7",
    bg: "https://cdn.prod.website-files.com/68cfd6257a8e7e88b64434d7/68cfd6257a8e7e88b64434de_Rectangle%20681.webp",
  },
  {
    icon: ShieldCheck,
    title: "Two electrical systems",
    body: "Separate front and rear electrical loops with motor overheat protection. If one circuit ever fails, you keep moving — built for remote use.",
    span: "md:col-span-5",
  },
  {
    icon: Waves,
    title: "Beach & water ready",
    body: "Waterproof motors and sealed components rated up to the battery box. Drive Stockton, K'gari and 75 Mile Beach. Cross creek fords without drama.",
    span: "md:col-span-5",
    bg: "https://cdn.prod.website-files.com/68cfd6257a8e7e88b64434d7/68cfd6257a8e7e88b64434e1_Rectangle%20684.webp",
  },
  {
    icon: Sun,
    title: "Class 3 dual purpose",
    body: "Registered as a Class 3 medical mobility device — legal on Australian footpaths and roads as well as off-road tracks. One vehicle, every surface.",
    span: "md:col-span-7",
  },
  {
    icon: BatteryCharging,
    title: "Lithium range options",
    body: "Standard 24 V / 100 Ah lithium for ~37 km. Upgrade to 150 Ah (~55 km) or 200 Ah (~72 km) for full-day expeditions.",
    span: "md:col-span-4",
  },
  {
    icon: Wrench,
    title: "Comfort + safety built-in",
    body: "Side roll bar (lifts left or right for easy transfer), Exmoor Trim seat, lap belt, mirrors, LED lights and indicators — all standard.",
    span: "md:col-span-8",
  },
];

export default function BuiltForOutback() {
  return (
    <section id="features" data-testid="features" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="max-w-3xl">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-primary">
            Built to Roam
          </span>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl uppercase tracking-tight font-bold leading-[1.05]">
            Not a buggy. Not a quad. <br />
            <span className="text-primary">An all-terrain mobility vehicle.</span>
          </h2>
          <p className="mt-6 text-base md:text-lg text-muted-foreground leading-relaxed max-w-2xl">
            The Overlander 4 is engineered for people who refuse to let mobility challenges keep
            them off the tracks. Six features that matter when you&apos;re a long way from the ute.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-12 gap-5">
          {FEATURES.map((f) => (
            <article
              key={f.title}
              data-testid={`feature-${f.title.toLowerCase().replace(/\s+/g, "-")}`}
              className={`relative ${f.span} group bg-card border border-border rounded-sm p-7 md:p-8 overflow-hidden transition-all duration-300 hover:border-primary hover:-translate-y-1`}
            >
              {f.bg && (
                <div
                  className="absolute inset-0 opacity-15 bg-cover bg-center group-hover:opacity-25 transition-opacity duration-500"
                  style={{ backgroundImage: `url(${f.bg})` }}
                />
              )}
              <div className="relative">
                <span className="inline-flex h-10 w-10 items-center justify-center bg-primary text-primary-foreground rounded-sm">
                  <f.icon className="h-5 w-5" />
                </span>
                <h3 className="mt-5 font-display text-xl md:text-2xl font-semibold uppercase tracking-tight">
                  {f.title}
                </h3>
                <p className="mt-3 text-sm md:text-base text-muted-foreground leading-relaxed">
                  {f.body}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
